import axios from "axios";

export const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

let refreshing = null;
API.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config;
    if (error.response?.status === 401 && !orig._retry && !orig.url.includes("/auth/")) {
      orig._retry = true;
      try {
        refreshing = refreshing || API.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return API(orig);
      } catch {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function fmtErr(e, fallback = "Something went wrong") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export const logErr = (...args) => {
  if (process.env.NODE_ENV !== "production") logErr(...args);
};
